import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'progress-bar',
  templateUrl: 'progress-bar.component.html',
  standalone: true,
  styleUrls: ['./progress-bar.component.scss'],
  imports: [NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBarComponent {
  percent = input<number>(0);
  disabled = input<boolean>(false);
}
